import {
  TEAM_LIST_LOADING,
  GET_TEAM_LIST_ERROR,
  GET_TEAM_LIST,
  GET_TEAM_BY_ID_LOADING,
  GET_TEAM_BY_ID_SUCCESS,
  GET_TEAM_BY_ID_ERROR,
  DELETEING_TEAM,
  DELETE_TEAM,
  DELETE_TEAM_ERROR,
  DELETED_TEAM_LIST_LOADING,
  GET_DELETED_TEAM_LIST,
  GET_DELETED_TEAM_LIST_ERROR,
  PERMA_DELETEING_TEAM,
  PERMA_DELETE_TEAM,
  PERMA_DELETE_TEAM_ERROR,
  RESTORE_TEAM_LIST_LOADING,
  RESTORE_TEAM_LIST,
  RESTORE_TEAM_LIST_ERROR,
} from "./types";

const INITIAL_STATE = {
  data: undefined,
  loading: false,
  error: false,
  dataById: undefined,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TEAM_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_TEAM_BY_ID_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETEING_TEAM:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETED_TEAM_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case PERMA_DELETEING_TEAM:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case RESTORE_TEAM_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case GET_TEAM_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case GET_TEAM_BY_ID_SUCCESS :
      return {
        ...state,
        loading: false,
        dataById: action.payload.data,
        error: false,
      };
    case GET_DELETED_TEAM_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case DELETE_TEAM:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case PERMA_DELETE_TEAM:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case RESTORE_TEAM_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case GET_TEAM_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_TEAM_BY_ID_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_DELETED_TEAM_LIST_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case DELETE_TEAM_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case PERMA_DELETE_TEAM_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case RESTORE_TEAM_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };

    default:
      return state;
  }
};

export default reducer;